import { Action, Pill } from '@/types/EntityDetails';
import React from 'react';
import { Divider } from '../misc';

type EntityDetailsSummaryTabletViewProps = {
  icon?: JSX.Element;
  entityPills?: Pill[];
  actions?: Action[];
  basicInfo: JSX.Element[];
  pills: JSX.Element[];
  entityGrid: JSX.Element[];
  actionButtons: JSX.Element[];
};

const EntityDetailsSummaryTabletView = ({ icon, entityPills, basicInfo, pills, entityGrid, actions, actionButtons }: EntityDetailsSummaryTabletViewProps) => (
  <div className="entity-summary-info-card">
    <div className="entity-summary-info-container">
      <div className="entity-summary-basic-info-container">
        <div className="entity-summary-basic-info">
          {icon && icon}
          <div className="entity-summary-basic-info-fields">{basicInfo}</div>
          {entityPills && entityPills.length > 0 && <div className="entity-summary-pills-container">{pills[0]}</div>}
        </div>
        {entityGrid.length > 0 && (
          <>
            <Divider className="entity-summary-details-tablet-divider" />
            <div className="entity-summary-details-fields">{entityGrid}</div>
          </>
        )}
      </div>
    </div>
    {actions && <div className="entity-summary-actions-container">{actionButtons}</div>}
  </div>
);

export default EntityDetailsSummaryTabletView;
